import * as t from "./types.js";

import type { PromptContext } from "../context.js";

const DEFINITION_ARBEITS_WEGE_UNFALL_ODER_BERUFSKRANKNHEIT =
	"Ein Arbeits-, Schul- oder Wegeunfall sind Unfälle, die ein Arbeitnehmer oder Schüler während der Arbeitszeit oder auf den direkten Arbeitsweg erleidet! Eine Berufskrankheit ist eine Krankheit, die sich der Versicherte durch eine berufliche Tätigkeit zugezogen hat.";

export class Prompts {
	private ctx: PromptContext;

	constructor(context: PromptContext) {
		this.ctx = context;
	}

	public vorhaltung() {
		return this.ctx.io.in.select({
			title:
				"Fand dein Einsatz im Rahmen des Hauptaufgabengebietes nach BayRDG statt?",
			description:
				"Hauptaufgaben: Krankentransport, Notfallrettung, Notarztdienst",
			choices: [
				{
					name: "Ja, **Regelvorhaltung**",
					value: t.Vorhaltung.Regelvorhaltung,
					description:
						"Rettungsmittel die öffentlich-rechtlich regelhaft vorgehalten werden",
				},
				{
					name: "Nein, Sonderbedarf",
					value: t.Vorhaltung.Sondereinsatz,
					description: "z.B: LRD, UGRD, ORGL, ELRD, HvO, SEG-Einsatz",
				},
			],
		});
	}

	public kvTyp() {
		return this.ctx.io.in.select({
			title: "In welchem Rahmen fand der Einsatz statt?",
			choices: [
				{
					name: "**Öffentlich-Rechtliche Vorhaltung**",
					value: t.KvTyp.ÖffentlicheRechtlicheVorhaltung,
				},
				{
					name: "Temporäre Vorhalteerhöhung",
					value: t.KvTyp.TemporäreVohalteerhöhung,
				},
				{
					name: "BayKSG (Katastrophenschutzgesetz)",
					value: t.KvTyp.BayKSG,
				},
				{
					name: "Bergrettung- / Wasserrettung- / Luftrettungsdienst",
					value: t.KvTyp.WasserrettungBergrettung,
				},
				{
					name: "Private Leistungserbringung außerhalb des öffentlich-rechtlichen Rettungsdienst, jedoch Disposition durch ILS",
					value: t.KvTyp.Privat,
				},
			],
		});
	}

	public vorhalteErhöhungFinanzierungDurchKtr() {
		return this.ctx.io.in.selectBool(
			"Wird die Vorhalteerhöhung durch die Kostenträger oder den Betreiber finanziert?",
		);
	}

	public einsatzSzenario() {
		return this.ctx.io.in.select({
			title: "Was beschreibt die Hauptaufgabe der Fahrt am besten?",
			description: "*Dein Fahrzeug wurde alarmiert weil...*",
			choices: [
				{
					name: "Fahrt zu einem Einsatz **als Transportmittel**",
					description:
						"Transportmittel nach DIN1789 wie: KTW, N-KTW, RTW wird zu KTP, Notfall o.ä alarmiert. Ausschließlich bei Beauftragung durch zuständige ILS",
					value: t.EinsatzZweck.Transport,
				},
				{
					name: "Zubringen eines Arztes",
					description:
						"Ein Notarzt oder Verlegungsarzt wurde durch die Leitstelle alarmiert und an die Einstalstelle verbracht.\nTypischerweise: NEF, VEF Einsätze\nAuch zu nutzen wenn NEF oder VEF defekt, besetzt oder anderweitig belegt ist und ein anderes Fahrzeug genutzt wird.",
					value: t.EinsatzZweck.ArztZubringer,
				},
			],
		});
	}

	public transportUrsprungOderZielHuLaPla() {
		return this.ctx.io.in.selectBool(
			"Ist der Einsatz- oder Zielort ein Hubschrauberlandeplatz?",
			"**Hier geht es ausschließlich um einen festen Hubschrauberlandeplatz eines Klinikums!** Transport von Hubschrauberlandeplatz in Einrichtung **oder** von Einrichtung zum Hubschrauberlandeplatz, dann Übernahme durch RTH / ITH",
		);
	}

	public herabstufungGrundKTP() {
		// TODO: Andere KTP Gründe? Also Notfall zum Kathetherwechsel...?!
		return this.ctx.io.in.select({
			title: "Wodruch wird dein Einsatz am besten beschrieben?",
			choices: [
				{
					name: "Verlegung",
					description: "Verlegung von KHS A zu KHS B",
					value: t.NotfallTyp_Downgrade.Verlegung,
				},
				{
					name: "Schul-, Wege-, Arbeitsunfall oder ursächlich einer anerkannten Berufskrankheit",
					description: DEFINITION_ARBEITS_WEGE_UNFALL_ODER_BERUFSKRANKNHEIT,
					value: t.NotfallTyp_Downgrade.ArbeitsOderWegeOderSchulUnfall,
				},
				{
					name: "Sonstiger Unfall (Traumatisch)",
					value: t.NotfallTyp_Downgrade.SonstigerUnfall,
				},
				{
					name: "Sonstiger Einsatz (Internistisch, Neurologisch, ...)",
					value: t.NotfallTyp_Downgrade.SonstigerEinsatz,
				},
				{
					name: "Neugeborenen Holdienst - Inkubatortransport mit Begleitung eines **Klinik**-Behandlungsteams!",
					value: t.NotfallTyp_Downgrade.Holdienst,
				},
			],
		});
	}

	public verlegungBegleitungKVB() {
		return this.ctx.io.in.selectBool(
			"Wurde die Verlegung durch einen diensthabenden **KVB-Verlegungsarzt** begleitet?",
		);
	}

	public dispositionsStichwort() {
		return this.ctx.io.in.select({
			title: "Disposition des Einsatzes als...",
			description:
				"Was steht als Stichwort im Alarmtext? Hier geht es um das letztendlich durch die Leitstelle gewählte Stichwort",
			choices: [
				{
					name: "**#RD1** — Notfall **ohne** Notarzt",
					value: t.Stichwort.RD_1,
					description: "Auch #RD0 oder #RD#Überörtlich",
				},
				{
					name: "**#RD2** *oder höher* — Notfall **mit** Notarzt",
					value: t.Stichwort.RD_2,
					description:
						"RD2, RD3, RD4, RD5 - MIT planmäßiger Beteiligung eines Notarzt",
				},
				{
					name: "**#RD#KTP** — Krankentransport",
					value: t.Stichwort.RD_KTP,
					description: "#RD#KTP#90XX - auch Prio.2 (#9017) Einsätze!",
				},
				{
					name: "#RD#VEF",
					value: t.Stichwort.RD_VEF,
					description:
						"Verlegung mit VEF (Verlegungseinsatzfahrzt, Verlegungsarzt)",
				},
				{
					name: "#RD#ITW",
					value: t.Stichwort.RD_ITW,
					description: "Nur bei Verwendung des Stichworts: #RD#ITW durch ILS",
				},
				{
					name: "#RD#Sonstige#MANV",
					value: t.Stichwort.RD_MANV,
					description: "Massenanfall von Verletzten - egal welcher Größe",
				},
				{
					name: "#RD#Sonstige#**Gebietsabsicherung**",
					value: t.Stichwort.RD_Absicherung_Gebietsabsicherung,
					description:
						"Sicherstellung der Einsatzfähigkeit in einem anderen Rettungsdienstbereich bzw. Einsatzgebiet einer anderen Rettungswache",
				},
				{
					name: "#RD#Sonstige#**Dienstfahrt**",
					value: t.Stichwort.RD_Absicherung_Dienstfahrt,
					description:
						"Voraussetzungen:\n1. Durchführung nur auf Anordnung durch KGF oder RDL\n2. Leitstelle muss davon unterrichtet sein und muss innerhalb der Vorhaltezeit diese Fahrt genehmigen\noder: nötige Fahrten zur Personalumsetzung",
				},
				{
					name: "#RD#Sonstige#**Werkstattfahrt**",
					value: t.Stichwort.RD_Sonstige_Werkstattfahrt,
					description:
						"Direkter Zusammenhang mit Reparatur eines Rettungsdienstfahrzeugs muss vorliegen",
				},
			],
		});
	}

	public bodengebundenerNotarzt() {
		return this.ctx.io.in.selectBool(
			"War ein **bodengebundener** Notarzt **ebenfalls** an der **VERSORGUNG** beteiligt?",
		);
	}

	public transportBeiHeliBeteiligung() {
		return this.ctx.io.in.select({
			title: "Was beschreibt den Transport am besten? **Der Patient...**",
			description:
				"**Jeweils bei Transport in Behandlungseinrichtung!** Auch Nein, wenn kein Patient angetroffen wurde oder sichere Todeszeichen bei Eintreffen aufweist!",
			choices: [
				{
					name: "...wurde **nicht** transportiert",
					value: t.RthTransportTyp.KeinTransport,
				},
				{
					name: "...wurde mit **ihrem** Fahrzeug transportiert",
					value: t.RthTransportTyp.Bodengebunden,
				},
				{
					name: "...wurde mit dem **Helikopter** transportiert",
					value: t.RthTransportTyp.Luftgebunden,
				},
			],
		});
	}

	public anderesFahrzeugTransportiert() {
		return this.ctx.io.in.select({
			title:
				"War ein anderes Fahrzeug beteiligt, welches den Transport des Patienten übernommen hat?",
			description:
				"Beispiel: KTW zur Erstversorgung, RTW übernimmt dann Transport",
			choices: [
				{
					name: "Ja, an **Luft**rettungsmittel",
					value: t.ÜbergabeTyp.Luftgebunden,
				},
				{
					name: "Ja, an **Land**rettungsmittel",
					value: t.ÜbergabeTyp.Bodengebunden,
				},
				{ name: "Nein", value: t.ÜbergabeTyp.Keine },
			],
		});
	}

	public sonstigerNotfallKrankenhausTräger() {
		return this.ctx.io.in.selectBool(
			"Wurde von einem Krankenhaus abtransportiert *und* gibt es einen triftigen Grund weshalb das Krankenhaus die Kosten für den Transport tragen muss?",
			"Beispiel: Keine zwingende Begründung für Transport mit Notarzt!",
		);
	}

	public ablehnungsgrundNotarzt_NurRdAusreichend() {
		return this.ctx.io.in.selectBool(
			"Wäre eine reine Hilfeleistung durch den Rettungsdienst *ohne Notarzt* ausreichend gewesen?",
			"Entscheidungshilfe: Hätte eine Nachforderung durch den Rettungsdienst stattgefunden, wenn der Notarzt nicht eh schon alarmiert gewesen wäre?",
		);
	}

	public async ablehnungsgrundNotarzt() {
		if (!(await this.ctx.prompts.wurdePatientTransportiert())) {
			if (await this.ablehnungsgrundNotarzt_NurRdAusreichend()) {
				return t.AblehungsgrundNotarzt.KeineLeistung;
			}
		}

		return this.ctx.io.in.select({
			title: `Trifft eine der folgenden Aussagen zu? **Der Notarzt...**`,
			choices: getAbrechnungsfähigkeitNotarztChoices(false),
		});
	}

	public wahrnehmungAlsNotfall() {
		// TODO: Hilfestellung in Beschreibung - wie definiert?
		return this.ctx.io.in.selectBool(
			"Wahrnehmung des Patientenzustands durch RD-Personal am Einsatzort als Notfall?",
			`
**Faustregel**
1. Wurden beim Transport Sonder-/Wegerechte (Blaulicht) eingesetzt? *oder...*
2. Wurde eine Behandlung durchgeführt welche einen schweren gesundheitlichen Schaden abgewendet hat?
<hr/>

##### Definition "Rettungsfahrt" nach §5 KTP-RL - Notfall
> Patienten bedürfen einer Rettungsfahrt, wenn sie aufgrund ihres Zustands mit einem qualifizierten Rettungsmittel (RTW, ...) befördert werden müssen oder der Eintritt eines derartigen Zustands während des Transports zu erwarten ist.

##### Definition "Krankentransport" nach §6 KTP-RL - Kein Notfall
> Ein Krankentransport kann verordnet werden, wenn Patientinnen oder Patienten während der Fahrt einer fachlichen Betreuung oder der besonderen Einrichtungen des KTW bedürfen oder deren Erforderlichkeit aufgrund ihres Zustandes zu erwarten ist.

<hr/>
Auszug aus der <a href="https://www.g-ba.de/richtlinien/25/">Krankentransport Richtlinie</a>
`,
		);
	}

	public wurdePatientTransportiert() {
		return this.ctx.io.in.selectBool(
			"Wurde ein Patient mit **ihrem** Fahrzeug **transportiert**?",
			`Nur "Ja", bei Transport zu verrechenbarem Zielort. Beispiel: "Nach Hause" fahren bei Notfalleinsatz nicht erlaubt!`,
		);
	}

	public welchesEingesetzteFahrzeug() {
		return this.ctx.io.in.select({
			title: "Auf welchem Fahrzeug bist du eingesetzt?",
			choices: [
				{ name: "KTW, N-KTW", value: t.Fahrzeug.KTW },
				{
					name: "RTW",
					description: "auch: V-RTW (Verlegungs-RTW)",
					value: t.Fahrzeug.RTW,
				},
				{ name: "NEF", value: t.Fahrzeug.NEF },
				{ name: "VEF", value: t.Fahrzeug.VEF },
				{ name: "NAW", value: t.Fahrzeug.NAW },
				{ name: "ITW", value: t.Fahrzeug.ITW },
			],
		});
	}

	public warNotarztBeteiligt() {
		return this.ctx.io.in.selectBool(
			"War ein **diensthabender Notarzt** an der **VERSORGUNG** ihres Patienten beteiligt?",
			`<span style="color: red">**Ein Klinik-, zufällig anwesender Not-, oder Hausarzt zählt hier nicht!**</span>
			Ausschließlich: Diensthabende oder durch ILS in Dienst gestellte Verlegungs-, oder Notärzte welche **aktiv** an der Patientenversorgung teilgenommen haben!
			**Unabhängig von Transportbegleitung durch den Notarzt!**`,
			"Ja",
			"Nein / Abbestellt",
		);
	}

	public wurdePatientAngetroffen() {
		return this.ctx.io.in.selectBool(
			"Wurde ein Patient durch den Rettungsdienst angetroffen?",
			`Beispiele für "nein": Vorsorgliche Bereitstellung, Kein Patient auffindbar, Dein Fahrzeug wurde durch die ILS abbestellt`,
		);
	}

	public beiEintreffenSichereTodeszeichen() {
		return this.ctx.io.in.selectBool(
			"Lagen bei Eintreffen sichere Todeszeichen vor?",
			`Wenn eine Reanimation stattfand, auch wenn diese erfolglos war (!), muss diese Frage mit Nein beantwortet werden.`,
		);
	}

	public istKrankenkasseBekannt() {
		return this.ctx.io.in.selectBool(
			"Ist die Krankenkasse oder Unfallversicherung des Patienten bekannt?",
		);
	}

	public verlegungInKrankenhausNiedrigerVersorungsstufe() {
		return this.ctx.io.in.selectBool(
			"Wurde in ein Krankenhaus mit gleicher oder niedrigerer Versorgungsstufe verlegt?<br/>*oder:* Handelt es sich um eine Verbringung (Konsilfahrt)?",
			`
Beispiel: Bettenmangel im abgebenden Krankenhaus. Auch ja: Bei jedem *anderem* Grund, wenn das abgebende Krankenhaus den Transport zahlen muss!

<hr/>

Definitionen:
- **Versorgungsstufe** = Einteilung durch das STMGP <a href="https://www.stmgp.bayern.de/gesundheitsversorgung/krankenhaeuser/">hier</a> einsehbar.
- **Verbringung** = Patienten werden während eines stationären Krankenhausaufenthaltes zu einer ärztlichen Leistung an
einen anderen Ort transportiert und anschließend - zumeist am selben Tag (24 h) - wieder
zurückgebracht. (zumeist: Konsilfahrt).
- Verlegung = Transport eines Patienten von einem Krankenhaus in ein anderes zur weiteren stationären Aufnahme.
`,
		);
	}

	public istPrivateOderUnbekannteKrankenkasse() {
		return this.ctx.io.in.selectBool(
			"Ist der Patient privat versichert **oder** die Krankenversicherung unbekannt?",
		);
	}

	public istUrsacheBG() {
		return this.ctx.io.in.selectBool(
			"Ist ein Schul-, Arbeits-, Wegeunfall oder eine anerkannte Berufskrankheit ursächlich für den Einsatz?",
			DEFINITION_ARBEITS_WEGE_UNFALL_ODER_BERUFSKRANKNHEIT,
		);
	}

	public istBerufsgenossenschaftBekannt() {
		return this.ctx.io.in.selectBool(
			"Ist die zuständige Berufsgenossenschaft bekannt?",
		);
	}

	public notfallSzenarioOhneNA() {
		return this.ctx.io.in.select({
			title: "Was beschreibt deinen Einsatz am besten?",
			choices: [
				{
					name: "Arbeitsunfall / Wegeunfall",
					value: t.NotfalleinsatzTyp.ArbeitsOderWegeUnfall,
					description: `${DEFINITION_ARBEITS_WEGE_UNFALL_ODER_BERUFSKRANKNHEIT}. Notfalleinsatz am Arbeitsplatz/Schule oder auf dem Weg von/zum Arbeitsplatz/Schule.\nInternistische Notfälle fallen nicht unter diese EA!`,
				},
				{
					name: "Schulunfall",
					value: t.NotfalleinsatzTyp.Schulunfall,
					description:
						"Notfalleinsatz innerhalb des Schulgeländes. Internistische Notfälle fallen nicht unter diese EA!",
				},
				{
					name: "Verkehrsunfall",
					value: t.NotfalleinsatzTyp.Verkehrsunfall,
					description: "Unfall mit Verkehrsfahrzeug jeder Art",
				},
				{
					name: "Verlegung",
					value: t.NotfalleinsatzTyp.Verlegung,
					description: "Verlegung von KHS A nach KHS B",
				},
				{
					name: "Verlegung mit VRTW (Verlegungs-RTW)",
					value: t.NotfalleinsatzTyp.Verlegung_VRTW,
					description:
						"Notfalleinsatz, dringende und planbare Verlegung ohne ITW-Bedarf",
				},
				{
					name: "Internistischer Notfall",
					value: t.NotfalleinsatzTyp.Internistisch,
					description: "Jeder Internistische Nofall.",
				},
				{
					name: "Sonstiger Unfall",
					value: t.NotfalleinsatzTyp.SonstigerUnfall,
					description:
						"Jeder Unfall (bzw. Trauma) welcher nicht von den anderen Unfallarten besser beschrieben ist.\nHaus- und Sportunfälle, welche nicht Schul-, Arbeits- oder Wegeunfälle sind",
				},
				{
					name: "Sonstiger Notfall",
					value: t.NotfalleinsatzTyp.SonstigerNofall,
					description:
						"Notfalleinsatz, welcher mit keiner anderen Einsatzart definiert ist.",
				},
				{
					name: "Neugeborenen Holdienst - Inkubatortransport mit Begleitung eines **Klinik**-Behandlungsteams!",
					value: t.NotfalleinsatzTyp.NeugeborenenHoldienst,
					description:
						"Abholung des Behandlungsteams und Transport zum anfordernden KHS. Transport des Behandlungsteam und des Neugeborenen in das Kinder-KHS",
				},
			],
		});
	}

	public holdienstBegleitungDurchKlinik() {
		return this.ctx.io.in.selectBool(
			"War ein Behandlungsteam des Klinikums beteiligt?",
		);
	}

	public holdienstRegion() {
		return this.ctx.io.in.select({
			title: "In welcher Region fand der Holdienst statt?",
			choices: [
				{ name: "Augsburg", value: t.HoldienstTyp.Augsburg },
				{ name: "Landshut", value: t.HoldienstTyp.Landshut },
				{ name: "*Andere Region*", value: t.HoldienstTyp.Andere },
			],
		});
	}

	public krankentransportSzenario() {
		return this.ctx.io.in.select({
			title: "Was beschreibt den Einsatz am besten?",
			description:
				"**KHS** = Krankenhaus, **Behandlungseinrichtung** = KHS oder Ambulante Praxis oder sonstige ambulante Therapie",
			choices: [
				{
					name: "Fahrt zu **stationärer** Aufnahme in KHS",
					value: t.KrankentransportTyp.KtpZumKh,
					description:
						"1. Fahrt zur stationären Aufnahme; 2. Ausgangsort ist **KEIN** Krankenhaus",
				},
				{
					name: "Fahrt zu oder von **ambulanter** Behandlung in einem **Krankenhaus**",
					value: t.KrankentransportTyp.AmbulanzfahrtNichtGenehmigt_KHS,
					description:
						"**Einsatzort ist kein Krankenhaus, falls ja -> Verlegung!** z.B Katheterwechsel in KHS; Nur ambulante Behandlung, wenn diese nicht durch eine andere Einsatzart besser beschrieben wird!",
				},
				{
					name: "Fahrt zu oder von **ambulanter** Behandlung in **Ambulanz**, außerhalb eines Krankenhaus!",
					value: t.KrankentransportTyp.AmbulanzfahrtNichtGenehmigt_Ambulanz,
					description:
						"z.B Katheterwechsel in urologischer Praxis; Nur ambulante Behandlung, wenn diese nicht durch eine andere Einsatzart besser beschrieben wird!",
				},
				{
					name: "Fahrt zu/von **ambulanten Operation, vor- /nach-/teilstationären Behandlung**",
					value: t.KrankentransportTyp.AmbulanzfahrtGenehmigt,
				},
				{
					name: "Fahrten zur **Strahlen- und Chemotherapie** und sonstige **genehmigte Serienfahrten**",
					value: t.KrankentransportTyp.Serienfahrt,
				},
				{
					name: "Fahrt von oder zu **Dialyse**",
					value: t.KrankentransportTyp.Dialyse,
				},
				{
					name: "Verlegung von KHS A zu **stationärem** Aufenthalt in KHS B",
					value: t.KrankentransportTyp.Verlegung,
					description:
						"Verlegung aus stationärem Aufenthalt von KHS A nach KHS B",
				},
				{
					name: "**Verbringung** von KHS A zu **ambulanter Versorgung** in KHS B",
					value: t.KrankentransportTyp.AmbulanzfahrtKonsil,
				},
				{
					name: "Verlegung von KHS A in **heimatnahes** KHS",
					value: t.KrankentransportTyp.VerlegungInHeimkrankenhaus,
				},
				{
					name: "Heimfahrt aus **stationärem** Aufenthalt",
					value: t.KrankentransportTyp.Heimfahrt,
					description: "Zielort ist **kein** KHS",
				},
				{
					name: "Fahrt zu **Kurzzeitpflege** oder **Wohnungswechsel**",
					value: t.KrankentransportTyp.HeimfahrtWohnungswechel,
					description:
						"Kurzzeitpflege, Patient wird zu Hause gepflegt und die Angehörigen wollen für einige Wochen Urlaub machen. Dann wird der Patient in eine Pflegeeinrichtung verbracht. Wohnortverlegung, Patient lebt im Altenheim und sein Gesundheitszustand verschlechtert sich so, dass er in ein Pflegeheim umziehen muss",
				},
				{
					name: "Transport von **Blutkonserven** oder **medizinischem Gerät**",
					value: t.KrankentransportTyp.TransportMedGerät,
				},
				{
					name: "Transport von **Transplantaten** (primär: Organe)",
					value: t.KrankentransportTyp.TransplantatTransport,
				},
				{
					name: "Fahrt in Zusammenhang mit **Versorgungsleiden**",
					value: t.KrankentransportTyp.Versorgungsleiden,
				},
				{
					name: "Fahrt zwischen KHS Braunau und KHS Simbach (nur Fahrzeuge des KV211)",
					value: t.KrankentransportTyp.AmbulanzfahrtBraunauSimbach,
				},
				{
					name: "**Keine passende Beschreibung** - Sonstiger Krankentransport",
					value: t.KrankentransportTyp.Sonstiger,
				},
			],
		});
	}

	public liegtKrankentransportGenehmigungVor() {
		return this.ctx.io.in.selectBool(
			"Liegt eine Genehmigung der Krankenkasse für den Transport vor?",
			"Eine **Genehmigungnummer** der Krankenkasse muss vorliegen! Der Patient muss bei seiner Krankenkasse anrufen und sich den Transport genehmigen lassen!",
		);
	}

	public liegtGenehmigungsKulanzausnahmeVor() {
		return this.ctx.io.in.select({
			title: "Trifft eine der folgenden Aussagen zu? **Der Patient...**",
			choices: [
				{
					name: `hat einen Schwerbehindertenausweis mit dem Merkzeichen „aG“, „Bl“ oder „H“`,
					description: `Patienten welche "**a**ußergewöhnlich **G**ehbehindert", "**Bl**ind", oder "erheblich **H**ilfsbedürftig" sind. Nur wenn sie diese Eigenschaft durch Vorlage eines Schwerbehindertenausweis nachweisen können`,
					value: t.KtpKulanzGrund.AlleAußerDakVersicherte,
				},
				{
					name: "hat einen Pflegegrad 4 oder 5 oder bei Pflegegrad 3 zusätzlich eine (haus)ärztlich bestätigte dauerhafte Beeinträchtigung der Mobilität",
					description: "gemäß: § 15 SGB XI",
					value: t.KtpKulanzGrund.AlleAußerDakVersicherte,
				},
				{
					name: `wird am "selben Tag", Feiertag, Wochenende, Feiertag oder während Nacht-, Abendstunden transportiert`,
					description:
						"In diesen Fällen hatte der Patient keine Möglichkeit eine Genehmigung durch die Krankenkasse zu beantragen, weshalb eine Kulanzregelung greift!",
					value: t.KtpKulanzGrund.AlleKrankenkassen,
				},
				{
					name: "**Keine Aussage trifft zu**",
					value: t.KtpKulanzGrund.Keiner,
				},
			],
		});
	}

	public istBeiDakVersichert() {
		return this.ctx.io.in.selectBool(
			`Ist der Patient bei der "DAK" versichert?`,
		);
	}

	public ktpIstHinfahrtZuBehandlungseinrichtung() {
		return this.ctx.io.in.selectBool(
			"Handelt es sich um eine **Hinfahrt** in eine (ambulante) Behandlungseinrichtung",
			"Ambulante Behandlung auch in ZNA eines Krankenhaus möglich. Zumeist jedoch Ambulanzen eines MVZ, KH oder niedergelassenem Arzt",
		);
	}

	public ktpIstAmbulanteBehandlung() {
		return this.ctx.io.in.selectBool("Wurde ");
	}

	public notfallSzenarioMitNA() {
		return this.ctx.io.in.select({
			title: "Was beschreibt deinen Einsatz am besten?",
			description: `
- Arbeits-, Wege-, und Schulunfälle dürfen **nicht** als als Verkehrsunfall oder "Sonstiger Unfall" abgerechnet werden, wenn ein direkter Zusammenhang zwischen der schulischen oder beruflichen Tätigkeit besteht! Weil diese Einsätze nicht über die Berufsgenossenschaft abgerechnet werden können
- Internistische Notfälle können **nicht**, als "Unfall" abgerechnet werden. Beispiel: Ein Herzinfarkt am Arbeitsplatz ist keine BG-Sache!
      `,
			choices: [
				{
					name: "Arbeitsunfall / Wegeunfall",
					value: t.NotarzteinsatzTyp.ArbeitsOderWegeUnfall,
					description:
						"Notarzteinsatz am Arbeitsplatz/Schule oder auf dem Weg von/zum Arbeitsplatz/Schule.\nInternistische Notfälle fallen nicht unter diese EA!",
				},
				{
					name: "Schulunfall",
					value: t.NotarzteinsatzTyp.Schulunfall,
					description:
						"Notarzteinsatz innerhalb des Schulgeländes. Internistische Notfälle fallen nicht unter diese EA!",
				},
				{
					name: "Verkehrsunfall",
					value: t.NotarzteinsatzTyp.Verkehrsunfall,
					description: "Unfall mit Verkehrsfahrzeug jeder Art",
				},
				{
					name: "Verlegung",
					value: t.NotarzteinsatzTyp.Verlegung,
					description: "Verlegung von KHS A nach KHS B",
				},
				{
					name: "Internistischer Notfall",
					value: t.NotarzteinsatzTyp.Internistisch,
					description:
						"Jeder Internistische Nofall. Auch: Reanimation mit internistischer Ursache",
				},
				{
					name: "Sonstiger Unfall",
					value: t.NotarzteinsatzTyp.SonstigerUnfall,
					description:
						"Jeder Unfall (bzw. Trauma) welcher nicht von den anderen Unfallarten besser beschrieben ist.\nHaus- und Sportunfälle, welche nicht Schul-, Arbeits- oder Wegeunfälle sind",
				},
				{
					name: "Sonstiger Notfall",
					value: t.NotarzteinsatzTyp.SonstigerNofall,
					description:
						"Notarzteinsatz, welcher mit keiner anderen Einsatzart definiert ist.",
				},
			],
		});
	}
}

function getAbrechnungsfähigkeitNotarztChoices(transport: boolean) {
	return [
		{
			name: "...stammt von einem **Luftrettungsmittel**",
			description: "RTH, ITH",
			value: t.AblehungsgrundNotarzt.Luftrettungsmittel,
		},
		transport
			? {
					name: "...stammt von einem **ITW** oder **NAW**, ihr Fahrzeug übernimmt nur den Transport",
					description:
						"In diesem Fall kann durch das Transportmittel nur ein Krankentransport abgerechnet werden. Das Notarztbesetzte Transportmittel schreibt eine NAV",
					value: t.AblehungsgrundNotarzt.NAW_ITW,
				}
			: null,
		{
			name: "...hat **mehrere Patienten** an dieser Einsatzstelle versorgt, für **meinen Patienten wäre jedoch keine Notarztalarmierung erfolgt**, wenn kein Notarzt vor Ort gewesen wäre",
			description:
				"Zusätzlich am gleichen Einsatz versorgte Patienten können nur abgerechnet werden, wenn hier in der Theorie eine erneute Notarztalarmierung über die ILS erfolgt wäre.",
			value: t.AblehungsgrundNotarzt.MehrerePatienten,
		},
		{
			name: "...ist zum Einsatzzeitpunkt **nicht** an einem **bayerischen Notarztstandort** eingesetzt",
			description:
				"Notärzte die nicht in Bayern tätig sind können nicht an der Abrechnung teilnehmen. Ein Notarzt kann sich in seiner Rolle nicht selbstständig in Dienst versetzen!",
			value: t.AblehungsgrundNotarzt.NichtAusBayern,
		},
		{
			name: "...wurde **nicht** durch Meldung der KVB an die ILS in Dienst versetzt",
			description:
				"Ausschließlich die zuständige ILS kann einen Notarzt in seiner Rolle in Dienst versetzen. Eine nachträgliche Indienstsetzung durch die ILS ist möglich. Ein Notarzt kann sich in seiner Rolle nicht selbstständig in Dienst versetzen!",
			value: t.AblehungsgrundNotarzt.NichtImDienst,
		},
		{
			name: "...hat **keine** abrechnungsfähig ärztliche Leistung vollbracht",
			description:
				"Ärztliche Maßnahmen: Basisuntersuchung, Anamneseerhebung, Diagnostik, Versorgung (Therapie). Trifft nur äußerst selten zu, da bereits eine einfache Anamnese eine verrechenbare Leistung ist.",
			value: t.AblehungsgrundNotarzt.KeineLeistung,
		},
		{
			name: "...ist ein **Klinik-, KVB-, Hausarzt-, oder ein zufällig anwesender Arzt** (egal ob mit oder ohne Notarztqualifikation)",
			description:
				"Ein nicht in Dienst gestellter Arzt nimmt nicht an der Abrechnung teil. Ein Notarzt kann sich in seiner Rolle nicht selbstständig in Dienst versetzen.",
			value: t.AblehungsgrundNotarzt.NichtImDienst,
		},
		{
			name: "...ist als **Hintergrundnotarzt** tätig geworden",
			value: t.AblehungsgrundNotarzt.NichtImDienst,
		},
		{
			name: "**Keine Aussage trifft zu**",
			value: t.AblehungsgrundNotarzt.KeinGrund,
		},
	].filter((choice) => choice != null);
}
